import { render, staticRenderFns } from "./RemittanceSummary.vue?vue&type=template&id=0644b57e&scoped=true"
import script from "./RemittanceSummary.vue?vue&type=script&lang=js"
export * from "./RemittanceSummary.vue?vue&type=script&lang=js"
import style0 from "./RemittanceSummary.vue?vue&type=style&index=0&id=0644b57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644b57e",
  null
  
)

export default component.exports